// Registers Leaflet.GestureHandling: Ctrl/⌘+scroll (or trackpad pinch) zooms the
// MAP instead of the whole browser page; two fingers pan on touch; a one-finger
// drag or plain scroll shows a hint and lets the page scroll past. Import this
// module once (side effect) before rendering a map.
import "./leafletGlobal" // sets window.L first — must precede the plugin import
import L from "leaflet"
import * as GestureHandlingModule from "leaflet-gesture-handling"
import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css"

// The UMD exposes the handler as both a named (`GestureHandling`) and default
// export; Vite's interop can leave one undefined, so pick whichever resolved.
const mod = GestureHandlingModule as unknown as {
  GestureHandling?: unknown
  default?: unknown
}
const GestureHandling = mod.GestureHandling ?? mod.default
if (GestureHandling) {
  L.Map.addInitHook("addHandler", "gestureHandling", GestureHandling as never)
}

// Hebrew hint text (the plugin ships "iw" but navigator.language is "he", which
// it doesn't map — so we supply it explicitly).
export const GESTURE_TEXT_HE = {
  touch: "הזז את המפה באמצעות שתי אצבעות",
  scroll: "אפשר לשנות את מרחק התצוגה במפה באמצעות מקש Ctrl וגלילה",
  scrollMac: "אפשר לשנות את מרחק התצוגה במפה באמצעות מקש ⌘ וגלילה",
}
